export const pastLeaders = [
  {
    name: "Markus",
    image:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/236703hike-trip-lead.jpg",
    location: "Ijen & Bromo",
    quote:
      "The most memorable moment was when everyone made it to the summit together - the way the group encouraged and supported each other throughout the climb made it unforgettable.",
  },
  {
    name: "Larry",
    location: "French Alps",
    quote:
      "Leading trips is incredibly rewarding - it adds a whole new dimension of fun and makes each adventure uniquely special",
    image:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/277039larry-lead-trip.jpg",
  },
  {
    name: "Shawn",
    location: "Whaleshark Cebu",
    quote:
      "Dived into the ocean with whale sharks, and now I'm diving into the exciting world of leading trips and creating lifelong memories!",
    image:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/161077trip-lead-dive.jpg",
  },
];
